/* @flow */
import * as React from 'react';

import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';

import './styles/MessagesHeader.scss';

function MessagesHeader() {
  return (
    <header className="MessagesHeader">
      <Link
        className="MessagesHeader-brand"
        href={LinkConstants.MARKETING}
        eventElementName="MessagesHeader-brand">
        Remind
      </Link>
      <Button
        className="MessagesHeader-button"
        href={LinkConstants.SIGN_UP}
        size="small"
        eventElementName="MessagesHeader-button">
        Sign up
      </Button>
    </header>
  );
}

export default MessagesHeader;
